export default __webpack_public_path__ + "static/19-5406ec5ee93239aaa637d80ec5807b6f.webp";